<template>
  <div id="app">
    <router-view/>
    <!-- <global-uploader></global-uploader> -->
  </div>
</template>
<script>
    export default {
        name: 'app',
        data() {
            return {}
        }
    }
</script>
<style style="scss">
#app{
  background: #fff;
}
</style>
